<template>
  <div id="bind_wechat_outer">
    <div>
      <a class="iconfont close-button"
         href="javascript:void(null);"
         @click="$emit('close')"
         >&#xe639;</a>

      <div style="font-size: 1.5rem;color: #333;font-weight: bold;">更换微信</div>
      <div v-if="this.isWeixin()" style="width: 250px;height: 250px;display: flex;flex-direction: row;flex-wrap: nowrap;align-items: center;justify-content: center;">
        <el-button style="background-color: #fc1a34;color: white;"
                   @click="bindButtonClicked"
                   round>点击绑定</el-button>
      </div>
      <weixin-qr-code v-else style="margin-top: 20px;border: none;"></weixin-qr-code>

<!--      <el-button @click="testButtonClicked"> 测试一下</el-button>-->

    </div>
  </div>
</template>

<script>
  import WeixinQrCode from "../common/WeixinQrCode";
  import WeiXinManager from '../../js/weixin.config';
export default {
  name: "BindWechat",
  data() {
    return {
    }
  },
  components: {
    WeixinQrCode
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    wechatModel() {
      return this.$store.state.wechatModel;
    },
    httpManager() {
      return this.$store.state.http;
    }
  },
  watch: {
    wechatModel(val) {
      if (val != null) {
        this.uploadWechatData();
      }
    }
  },
  mounted() {
    if (this.wechatModel != null) {
      this.uploadWechatData();
    }
  },
  methods: {
    testButtonClicked() {
      let temp = this.$router.resolve({
        name: 'personalPage',
        query: {
          code: 'feli244',
          state: 100011,
        }
      });
      window.location.href = temp.href;
    },

    uploadWechatData() {
      let wechatModel = this.wechatModel;
      let params = {
        flag: 3,
        vxUnionid: wechatModel.unionid,
        vx: wechatModel.nickname
      }

      let _this = this;

      this.httpManager.ajax.ucProfileUpdate(params, function (data) {
        let code = data.code;
        if (code == 0) {
         _this.$toast('绑定成功');

         let user = _this.user;
         user.vxUnionid = wechatModel.unionid;
         _this.$store.commit('setUser', user);
         _this.$store.commit('setWechatModel', null);
         _this.$emit('close');
          return;
        }
        if (code == 5) {
          _this.$toast('当前微信已绑定其他账号！');
        } else {
          _this.$toast('绑定失败！');
        }
        _this.$store.commit('setWechatModel', null);
      }, function (data) {
        _this.$store.commit('setWechatModel', null);
        _this.$toast('绑定失败，请重新绑定！');
      });
    },
    bindButtonClicked() {
      WeiXinManager.jsapi_weixinLoginAutorize(window.location.href);
    },
  }
}
</script>

<style scoped>

  #bind_wechat_outer {
    background-color: rgba(0,0,0,0.3);
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-wrap: nowrap;
  }

  #bind_wechat_outer > div {
    background-color: white;
    width: 80%;
    max-width: 800px;
    min-width: 290px;
    padding-top: 40px;
    padding-bottom: 50px;
    position: relative;

    display: flex;
    flex-direction: column;
    align-items: center;
  }

  #bind_wechat_outer .close-button {
    position: absolute;
    top: 3px;
    right: 5px;
    font-size: 2rem;
    z-index: 999;
    text-decoration: none;
    color: black;
  }

</style>



// WEBPACK FOOTER //
// src/components/settings/BindWechat.vue